module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABJklEQVQokYXTzypFURQG8J/TGZmJPMB9gksM5AEoSvInlPsI/jzAfQhD06tQrpIoD0AG6uIBmJjIn8wlGZx1c+7uxDdZfWt/X3utvdbuazabSsixigVMYghvuMIxDvDVFWclYw03aGEujCLORf4mdD3mGq5R9zfqoat1zTnaGP7H2MUwjpBl0eNI6fAE54nhAp0SH8VKhrVEmGMxqhFxHq+Jbj3HeJKcVTzOOi6xG3wq0Y3kGKzoa0kxnh1sBk8xkOG94qAdN25EPKrQfGSK2ZVxHCW34uYWGjhLdLc59jFdSj5Fbr7UQj8+E/Nerli5bb/j2qoocSbhHRxmil1dxEuFqQovWMZ3dz0fMYG7f4z3oXug92M8KmbewCmeo6rn4A2MhQ78AAALPltvURY9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/closer.png
// module id = 900
// module chunks = 0